import getLetters from './getLetters'

export default function getCountLetters(text?: string | null): number {
  return getLetters(text).length
}
